var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tenant-project-guideline-section" }, [
    _c(
      "ul",
      {
        staticClass: "accordion accordion-customize",
        class: _vm.enableEdit ? "" : "view-only-guideline",
        attrs: {
          id: "tenant-project-guideline-accordion",
          "data-accordion": "",
          "data-deep-link": "true",
          "data-allow-all-closed": "true",
          "data-multi-expand": "true",
          "data-update-history": "true",
          "data-deep-link-smudge": "500",
        },
      },
      _vm._l(_vm.parsedGuidelines, function (section, index) {
        return _c(
          "li",
          {
            key: section.id,
            staticClass: "accordion-item accordion-item-customize",
            attrs: { "data-accordion-item": "" },
          },
          [
            _c(
              "a",
              {
                staticClass: "accordion-title accordion-customize-title",
                class: { "with-checkbox": _vm.enableEdit },
                attrs: { href: "#project-guideline-section-" + index },
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.displayOrder(section)))]),
                _vm._v(" "),
                _c("span", { staticClass: "section-title" }, [
                  _vm._v(_vm._s(section.value)),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion-content accordion-customize-content",
                attrs: {
                  id: "project-guideline-section-" + index,
                  "data-tab-content": "",
                },
              },
              [
                _c(
                  "ul",
                  { staticClass: "section-list" },
                  _vm._l(section.sectionContent, function (line, lineIndex) {
                    return _c(
                      "li",
                      { key: line.id, staticClass: "section-list-title" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "section-list-item",
                            class: { "with-checkbox": _vm.enableEdit },
                          },
                          [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "section-list-item__number" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(lineIndex + 1 + ".") +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "pre",
                                { staticClass: "section-list-item__value" },
                                [_vm._v(_vm._s(line.value))]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.isHKlandUser
                              ? _vm._l(
                                  line.actionTexts,
                                  function (rec, lIndex) {
                                    return _c(
                                      "div",
                                      {
                                        key: line.id + "_" + lIndex,
                                        staticClass: "update-history__text",
                                      },
                                      [_c("span", [_vm._v(_vm._s(rec))])]
                                    )
                                  }
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.enableEdit,
                              expression: "enableEdit",
                            },
                          ],
                          staticClass: "section-list-checkbox",
                          attrs: {
                            type: "checkbox",
                            disabled:
                              _vm.isInTechComment(
                                line.itemId,
                                section.itemId
                              ) &&
                              !_vm.isCheckedByCurrentUser(
                                line.itemId,
                                section.itemId
                              ),
                          },
                          domProps: {
                            checked: _vm.isInTechComment(
                              line.itemId,
                              section.itemId
                            ),
                          },
                          on: {
                            change: function (event) {
                              return _vm.changeTechComment(
                                section,
                                line,
                                event.target.checked
                              )
                            },
                          },
                        }),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }